import React from "react";
import { IMachine as Machine } from "../../../interfaces";
import ActionsTaskItem from "./ActionsTaskItem";
import InfosMachine from "./InfosMachine";

const MachineItem: React.FC<{ isListInView1: boolean; machine: Machine }> = ({
  isListInView1,
  machine,
}) => {
  return (
    <>
      <li key={machine.id} className="max-h-screen ">
        <article
          style={{ backgroundColor: "#E4EFF9", paddingTop:"0px" }}
          className={` hover:cursor-pointer border border-[#57852f]  rounded-md  pt-0 sm:p-4 flex text-left transition hover:shadow-lg hover:shadow-slate-500 dark:bg-slate-800 dark:hover:shadow-transparent ${
            isListInView1 ? "flex-row sm:h-32" : "sm:h-[340px]   flex-col "
          }`}
        >
          <InfosMachine machine={machine} isListInView1={isListInView1} />
          <ActionsTaskItem machine={machine} isListInView1={isListInView1} />
        </article>
      </li>
    </>
  );
};

export default React.memo(MachineItem);
